// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedWorkflow_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0808105 9.39331L2.91199 15.9994L0.0808105 22.6055L1.9191 23.3933L4.9191 16.3933L5.08792 15.9994L4.9191 15.6055L1.9191 8.60547L0.0808105 9.39331ZM12 15.9994C12 17.104 11.1045 17.9994 9.99996 17.9994C8.89539 17.9994 7.99996 17.104 7.99996 15.9994C7.99996 14.8948 8.89539 13.9994 9.99996 13.9994C11.1045 13.9994 12 14.8948 12 15.9994ZM25 15.9994C25 17.104 24.1045 17.9994 23 17.9994C21.8954 17.9994 21 17.104 21 15.9994C21 14.8948 21.8954 13.9994 23 13.9994C24.1045 13.9994 25 14.8948 25 15.9994ZM28.912 15.9994L26.0808 9.39331L27.9191 8.60547L30.9191 15.6055L31.0879 15.9994L30.9191 16.3933L27.9191 23.3933L26.0808 22.6055L28.912 15.9994ZM13.0808 9.39331L15.912 15.9994L13.0808 22.6055L14.9191 23.3933L17.9191 16.3933L18.0879 15.9994L17.9191 15.6055L14.9191 8.60547L13.0808 9.39331Z" class="svg-bg"/>
</svg>
`;
const _s40IconSvg = html `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0861811 11.406L3.89667 19.9998L0.0861811 28.5936L1.90949 29.4058L5.90006 20.4059L6.08014 19.9998L5.90006 19.5936L1.90949 10.5937L0.0861811 11.406ZM14.466 19.9998C14.466 21.1043 13.5727 21.9998 12.4707 21.9998C11.3688 21.9998 10.4754 21.1043 10.4754 19.9998C10.4754 18.8952 11.3688 17.9998 12.4707 17.9998C13.5727 17.9998 14.466 18.8952 14.466 19.9998ZM31.4259 19.9998C31.4259 21.1043 30.5326 21.9998 29.4306 21.9998C28.3287 21.9998 27.4353 21.1043 27.4353 19.9998C27.4353 18.8952 28.3287 17.9998 29.4306 17.9998C30.5326 17.9998 31.4259 18.8952 31.4259 19.9998ZM37.8165 19.9998L34.006 11.406L35.8293 10.5937L39.8199 19.5936L40 19.9998L39.8199 20.4059L35.8293 29.4058L34.006 28.5936L37.8165 19.9998ZM17.0461 11.406L20.8566 19.9998L17.0461 28.5936L18.8694 29.4058L22.86 20.4059L23.04 19.9998L22.86 19.5936L18.8694 10.5937L17.0461 11.406Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedWorkflow is a generated icon component.
 */
let IconMedWorkflow = IconMedWorkflow_1 = class IconMedWorkflow extends IconBaseElement {
    render() {
        return html `${IconMedWorkflow_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedWorkflow.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s40IconSvg],
    ['s48', _s40IconSvg],
    ['s64', _s40IconSvg],
    ['s72', _s40IconSvg],
    ['s80', _s40IconSvg],
]);
IconMedWorkflow = IconMedWorkflow_1 = __decorate([
    customElement('zui-icon-med-workflow')
], IconMedWorkflow);
export { IconMedWorkflow };
